// extracted by mini-css-extract-plugin
export default {"tasks":"sO-z","task":"tO-z","svg":"uO-z","text":"vO-z"};